(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("EffectiveInterestCalculator", [], factory);
	else if(typeof exports === 'object')
		exports["EffectiveInterestCalculator"] = factory();
	else
		root["EffectiveInterestCalculator"] = factory();
})(this, function() {
return 


/** WEBPACK FOOTER **
 ** webpack/universalModuleDefinition
 **/